module.exports = __webpack_public_path__ + "img/ic_menu.c7e373f4.svg";